/**
 * The filter mode of the texture.
 */
export enum TextureFilterMode {
  /** Point filtering. */
  Point = 0,
  /** Bilinear filtering. */
  Bilinear = 1,
  /** Trilinear filtering. */
  Trilinear = 2
}
